export default __webpack_public_path__ + "static/media/CreateInterviews.92d85960.svg";